/**
 * Utilidades para manipulación de temporadas.
 */

/**
 * Obtiene el nombre de una temporada a partir de su ID.
 * @param {Array} seasons — lista de temporadas
 * @param {number|string} seasonId — ID de la temporada
 * @returns {string}
 */
export function getSeasonName(seasons, seasonId) {
    if (!seasons) return `#${seasonId}`;
    const info = seasons.find(s => s.id == seasonId);
    return info?.nombre || `#${seasonId}`;
}
